module.exports = __webpack_public_path__ + "img/bk.ba426d92.png";